import { ChangeDetectionStrategy, Component, computed, effect, inject, input, output } from '@angular/core';
import { CustomerDisplayItem } from '@shared/customer/models/customer-display-item.model';
import { CustomerSearchItem, CustomerType } from '@shared/customer/models/customer-search-item.model';
import { CustomerSearchStateService } from '@shared/customer/services/customer-search-state.service';
import { CustomerService } from '@shared/customer/services/customer.service';

@Component({
  selector: 'app-payment-customer-section',
  templateUrl: './payment-customer-section.component.html',
  styleUrl: './payment-customer-section.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CustomerSearchStateService],
})
export class PaymentCustomerSectionComponent {
  private readonly customerService = inject(CustomerService);
  private readonly customerSearch = inject(CustomerSearchStateService);

  selectionTitle = input.required<string>();
  selectedCustomer = input<CustomerDisplayItem | null>(null);
  isEditMode = input<boolean>(false);

  customerChange = output<CustomerDisplayItem>();
  edit = output<void>();

  get customerData() {
    return this.customerSearch.customerData;
  }
  get isLoading() {
    return this.customerSearch.isLoading;
  }
  public selectedCustomerId = 0;

  private readonly syncSelectedCustomerEffect = effect(() => {
    const customer = this.selectedCustomer();
    if (!customer?.id) {
      this.selectedCustomerId = 0;
      this.customerSearch.clearData();
      return;
    }

    this.selectedCustomerId = customer.id;
    this.customerSearch.addToListIfMissing(this.customerService.mapCustomerDisplayItemToSearchItem(customer));
  });

  readonly isAnonymous = computed(() => this.selectedCustomer()?.isAnonymous ?? false);
  readonly isMoralCustomer = computed(() => this.selectedCustomer()?.customerType === CustomerType.Moral);

  public onClearTrigger(): void {
    this.selectedCustomerId = 0;
    this.customerSearch.clearData();
  }

  public onSearchTrigger(event: { searchTerm: string }) {
    this.customerSearch.triggerSearch(event.searchTerm);
  }

  onCustomerChange(customer: CustomerSearchItem): void {
    this.selectedCustomerId = customer.id;
    const displayItem: CustomerDisplayItem = {
      id: customer.id,
      name: customer.name,
      email: customer.email,
      zipCode: customer.zipCode,
      isAnonymous: customer.type !== 'Normal',
      identificationType: customer.type,
      customerType: customer.customerType,
    };
    this.customerChange.emit(displayItem);
  }

  onEdit(): void {
    this.edit.emit();
  }
}
